import { UAParser } from "ua-parser-js";
import appleDevices from "./appleDevices";

const checkDevice = () => {
  const parser = new UAParser();
  const uaData = parser.getResult();

  const { browser, os, device, ua } = uaData;

  const touchPoints = navigator.maxTouchPoints;
  const screenSize = {
    width: window.screen.width,
    height: window.screen.height,
    pixelRatio: window.devicePixelRatio,
  };

  const windowSize = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  let deviceInformation = {
    vendor: device.vendor,
    os: os.name,
    os_version: os.version,
    browser: browser.name,
    browser_version: browser.version,
    type: device.type,
    model: device.model,
  };

  // If no vendor do some manual checks
  if (!device.vendor || device.vendor === "Apple") {
    // Apple
    if (os.name === "Mac OS") {
      if (touchPoints > 0) {
        const devices = appleDevices.find(
          (d) =>
            d.width === screenSize.width &&
            d.pixelRatio === screenSize.pixelRatio,
        );

        deviceInformation = {
          ...deviceInformation,
          vendor: "Apple",
          type: "tablet",
          model: devices && devices.length > 0 ? devices.join(",") : "unknown",
        };
      } else {
        deviceInformation = {
          ...deviceInformation,
          vendor: "Apple",
          type: "desktop",
        };
      }
    }

    if (os.name === "iOS") {
      const devices = appleDevices.find(
        (d) =>
          d.width === screenSize.width &&
          d.pixelRatio === screenSize.pixelRatio,
      );
      deviceInformation = {
        ...deviceInformation,
        vendor: "Apple",
        model: devices && devices.length > 0 ? devices.join(",") : "unknown",
      };
    }

    if (os.name === "Linux" && browser.name === "Samsung Browser") {
      deviceInformation = {
        ...deviceInformation,
        vendor: "Samsung",
        os: "Android",
        type: "tablet",
      };
    }

    if (os.name === "Windows") {
      deviceInformation = {
        ...deviceInformation,
        type: "desktop",
      };
    }
  }

  return {
    ...deviceInformation,
    touchPoints,
    screenSize,
    windowSize,
    ua,
  };
};

export default checkDevice;
